/*
 * Title: Rewards/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: import Reward component form containers.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import Management from '@services/management-service';
import TemplatePage from "@pages/TemplatePage";

const RewardsPage = () => {
  const session = useSelector((state: any) => state.user.session);
  //const token = useSelector((state: any) => state.user.eToken);
  const { cname, pname } = useParams();
  const navigate = useNavigate();
  const management = Management.get();
  let sessionState = session?.[cname]?.[pname] ?? false;

  //useEffect(() => {
    if(management?.program?.config?.type == 'ecommerce'){
      if (!session?.[cname]?.[pname]) {
        navigate(`/${cname}/${pname}`);
      }
    } else {
      if (!(session?.[cname]?.[pname])) {
        navigate(`/${cname}/${pname}`);
      }
    }
    
  //}, []);

  return sessionState ? <TemplatePage /> : null;
};

export default RewardsPage;
